import axios from 'axios';

export const baseUrl = '/services/isnaportalsync/open-api/tax-debt-info';

export const infoAbsenceTaxDebt = (params: any, tokenStr: string) => {
    return axios.get(baseUrl, {
        params: params,
        headers: {
            Authorization: tokenStr,
        },
    });
};
